export { CorporativoTelco } from "./CorporativoTelco";
